import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, QueryParameter, ModalService, NotificationService } from 'yt-ng-framework';
import { Izvod } from './izvod';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { List } from 'immutable';
import { IzvodView } from './izvod-view';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-izvod-update',
  templateUrl: './izvod-update.component.html'
})
export class IzvodUpdateComponent extends BaseUpdateComponent<Izvod> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
) {
    super(activatedRoute, baseDataService, toastrService, translateService, modalService)
}

  parametersForPodvrstaDokumentStavka: List<QueryParameter> = List([]);
  PodvrstaDokumentStavkaIDParameter: QueryParameter = new QueryParameter();

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('Broj', Validators.required, 'required', 'IZVOD.BROJDOKUMENTA.VALIDATION.REQUIRED');
    this.addValidatorToFc('Broj', Validators.maxLength(20), 'maxlength', 'IZVOD.BROJDOKUMENTA.VALIDATION.MAXLENGTH');
    this.addValidatorToFc('PodVrstaDokumentaStavkaID', Validators.required, 'required', 'IZVOD.PODVRSTADOKUMENTASTAVKA.VALIDATION.REQUIRED');
    this.addValidatorToFc('Datum', Validators.required, 'required', 'IZVOD.DATUM.VALIDATION.REQUIRED');
    // this.addValidatorToFc('BankaID', Validators.required, 'required', 'IZVOD.BANKA.VALIDATION.REQUIRED');

    this.IDProcessed
            .subscribe((value) => {
                if (value && this.Item.ID == -1) {
                    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').enable();
                    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
                    this.baseFormGroup.get('Broj').enable();
                    this.baseFormGroup.get('Broj').updateValueAndValidity();
                    this.baseFormGroup.get('Datum').enable();
                    this.baseFormGroup.get('Datum').updateValueAndValidity();
                    let dateNow = new Date();
                    let date: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
                    this.baseFormGroup.patchValue({ Datum: date });
                    this.baseFormGroup.get('Datum').updateValueAndValidity();
                    this.enableControls();

                    this.parametersForPodvrstaDokumentStavka = List([]);
                    this.PodvrstaDokumentStavkaIDParameter.Name = "PodvrstaDokumentStavkaID";
                    this.PodvrstaDokumentStavkaIDParameter.Value = this.PodvrstaDokumentaItems.get(0)['ID'];
                    this.parametersForPodvrstaDokumentStavka = this.parametersForPodvrstaDokumentStavka.push(this.PodvrstaDokumentStavkaIDParameter);

                }
                else{
                    this.disableControls();
                }
            })
            this.ItemSaved
            .subscribe((data: IzvodView) => {
                if (data)
                    this.disableControls();
                    this.Item.BrojDokumenta = data.BrojDokumenta;

            })
           
  }

  PodvrstaDokumentaItems;
    PodvrstaDokumentaGetItems(items){
        this.PodvrstaDokumentaItems = items;
    }

  disableControls(){
    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').disable();
    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
    this.baseFormGroup.get('Broj').disable();
    this.baseFormGroup.get('Broj').updateValueAndValidity();
    this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
   
}

enableControls(){
    // this.baseFormGroup.get('PodVrstaDokumentaStavkaID').enable();
    // this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
    // this.baseFormGroup.get('Broj').enable();
    // this.baseFormGroup.get('Broj').updateValueAndValidity();
    this.baseFormGroup.enable();
    this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
   
}
  
  onPodVrstaSelect() {
    this.getBrojDokumenta();
}

  getBrojDokumenta() {
    let podvrstaid = this.baseFormGroup.get('PodVrstaDokumentaStavkaID').value;
    let datum = this.baseFormGroup.get('Datum').value;
    let _this = this;
    if (this.Item.ID == -1 && podvrstaid && datum)
        this.baseDataService.GetData('Izvod', 'KreirajBrojDokumenta', { 'PodVrstaDokumentaStavkaID': podvrstaid, 'Datum': datum })
            .subscribe(data => {
                if (_this.baseFormGroup.get('Datum').value){
                    this.baseFormGroup.patchValue({ Broj: data });
                    this.baseFormGroup.get('Broj').updateValueAndValidity();
                }
            })

}

editMode: boolean = false;
    AddDocument() { }
    //Print(ID1) { }
    item: any;
    PrintKnj(item1) { }
    SaveMaster(qq) { }
    onDatumChange(value) {
        if (value != null) {
            // let parameterList: List<QueryParameter> = List([new QueryParameter('Datum', value)]);
            // this.TransferParameters = this.TransferParameters.set(0, parameterList);
            this.getBrojDokumenta();
        }
    }

  onRestoreClick(): void {
    this.Reset(true).subscribe((result) => {
      if (result) {
        // console.log('Restore successfully executed');
      } else {
        // console.log('Restore was cancelled by the user');
      }
    });
  }


}
